var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"centerRight2"}},[_c('div',{staticClass:"chartInstanceBox"},[_c('div',{staticClass:"chartInstanceBoxTitle"},[_vm._v(" 项目类型占比 ")]),_c('div',{ref:"chartInstance",attrs:{"id":"chartInstance"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }